import { render, staticRenderFns } from "./MyClue.vue?vue&type=template&id=cb8bcc8c&scoped=true&"
import script from "./MyClue.vue?vue&type=script&lang=js&"
export * from "./MyClue.vue?vue&type=script&lang=js&"
import style0 from "./MyClue.vue?vue&type=style&index=0&id=cb8bcc8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8bcc8c",
  null
  
)

export default component.exports